import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = { class: "my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: _ctx.menu,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menu) = $event)),
    "close-on-content-click": false,
    "nudge-width": 200,
    "offset-y": ""
  }, {
    activator: _withCtx(({ props: propsMenu }) => [
      _createVNode(_component_v_tooltip, { bottom: "" }, {
        activator: _withCtx(({ props: propsTooltip }) => [
          _createVNode(_component_v_btn, {
            large: "",
            icon: "",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, _mergeProps({
                size: "30",
                color: "primary"
              }, $options.mergeProps(propsMenu, propsTooltip)), {
                default: _withCtx(() => [
                  _createTextVNode("mdi-palette")
                ]),
                _: 2
              }, 1040)
            ]),
            _: 2
          }, 1024)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Theme Colors ")
        ]),
        _: 2
      }, 1024)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, { flat: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Theme Colors")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_toolbar_items, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menu = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("$close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme, index) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  class: "my-2",
                  disabled: _ctx.$vuetify.theme.currentTheme.name === theme.name,
                  onClick: ($event: any) => ($options.setTheme(theme)),
                  hover: "",
                  outlined: "",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(theme.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            (_ctx.$vuetify.theme.currentTheme.name === theme.name)
                              ? (_openBlock(), _createBlock(_component_v_avatar, {
                                  key: 0,
                                  color: "success",
                                  size: "30"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-check")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(theme.dark), (key, index) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          class: "mx-1",
                          label: "",
                          color: theme.dark[key],
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(key), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(theme.light), (key, index) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          class: "mx-1",
                          label: "",
                          color: theme.light[key],
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(key), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}